import { envConfig } from '../../../env';
import { Post } from '@/service/request/server';

const baseApi = () => {
    function applyTicket(data) {
        return Post(`${envConfig.getCurrentApi()}/plat/sec/` + 'ticket/apply', data, {
            headers: {
                Type: `primary_time_${new Date().getTime()}`
            }
        });
    }

    return {
        applyTicket
    };
};

export const securityApi = baseApi();
